"use client";

import React from "react";

interface WheelRewardNavigationProps {
  total: number;
  currentIndex: number;
}

/**
 * Navigation dots indicator for multi-reward dialog
 */
export const WheelRewardNavigation: React.FC<WheelRewardNavigationProps> = ({ total, currentIndex }) => {
  if (total <= 1) return null;

  return (
    <div className="flex justify-center gap-2">
      {Array.from({ length: total }, (_, index) => (
        <div
          key={index}
          className={`h-2 rounded-full transition-all ${
            index === currentIndex ? "w-8 bg-cede-primary" : "w-2 bg-cede-text-secondary/30"
          }`}
        />
      ))}
    </div>
  );
};
